import type { AuditLogEntry } from "../../types";
import { createBaseService } from "./baseService";

type AuditLogBase = Omit<AuditLogEntry, "id">;

const base = createBaseService<AuditLogEntry, AuditLogBase>({
  tableName: "audit_log",
  searchColumns: ["entity_type", "actor_name"],
  skipAuditFields: true,
});

export class AuditLogService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
